(() => {
  if (window.RemediuTestimonialsLoaded) return;

  window.RemediuTestimonialsLoaded = true;

  const SELECTOR = '[data-rp-testimonials]';
  const instances = new WeakMap();

  class RemediuTestimonials {
    constructor(root, SwiperClass = window.Swiper) {
      this.root = root;
      this.SwiperClass = SwiperClass;
      this.swiper = null;
      this.blockCount = Number.parseInt(root.dataset.blockCount, 10) || 0;
      this.desktopSlides = Number.parseFloat(root.dataset.desktopSlides) || 4;
      this.mobileSlides = Number.parseFloat(root.dataset.mobileSlides) || 1;
      this.desktopGap = Number.parseInt(root.dataset.desktopGap, 10) || 20;
      this.mobileGap = Number.parseInt(root.dataset.mobileGap, 10) || 16;
      this.arrowsEnabled = root.dataset.arrowsEnabled !== 'false';
      this.init();
    }

    init() {
      const slider = this.root.querySelector('.rp-testimonials__swiper');
      const minimumVisibleSlides = Math.min(this.mobileSlides, this.desktopSlides);

      if (!slider || !this.SwiperClass || this.blockCount <= minimumVisibleSlides) return;

      const nextButton = this.root.querySelector('.rp-testimonials__button--next');
      const previousButton = this.root.querySelector('.rp-testimonials__button--prev');
      const hasDesktopOverflow = this.blockCount > this.desktopSlides && this.arrowsEnabled;

      this.swiper = new this.SwiperClass(slider, {
        a11y: {
          enabled: true,
          nextSlideMessage: 'Recenzia urmatoare',
          prevSlideMessage: 'Recenzia anterioara',
        },
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        loop: false,
        navigation: {
          enabled: false,
          nextEl: nextButton,
          prevEl: previousButton,
        },
        observer: true,
        observeParents: true,
        slidesPerView: this.mobileSlides,
        spaceBetween: this.mobileGap,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: Math.min(this.desktopSlides, 2),
            spaceBetween: this.desktopGap,
          },
          990: {
            navigation: {
              enabled: hasDesktopOverflow,
            },
            slidesPerView: this.desktopSlides,
            spaceBetween: this.desktopGap,
          },
        },
      });
    }

    selectBlock(block) {
      if (!this.swiper || !block) return;

      const slides = Array.from(this.root.querySelectorAll('.rp-testimonials__slide'));
      const index = slides.indexOf(block);

      if (index >= 0) this.swiper.slideTo(index);
    }

    destroy() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  const mount = (root) => {
    if (!root || instances.has(root)) return;

    instances.set(root, new RemediuTestimonials(root));
  };

  const unmount = (root) => {
    const instance = instances.get(root);

    if (!instance) return;

    instance.destroy();
    instances.delete(root);
  };

  const mountWithin = (container = document) => {
    if (container.matches?.(SELECTOR)) mount(container);
    container.querySelectorAll?.(SELECTOR).forEach(mount);
  };

  window.RemediuTestimonials = RemediuTestimonials;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountWithin());
  } else {
    mountWithin();
  }

  document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);

    unmount(root);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target.closest?.('.rp-testimonials__slide');
    const root = block?.closest(SELECTOR);
    const instance = root ? instances.get(root) : null;

    instance?.selectBlock(block);
  });
})();
